import React, { useState, useEffect, useRef } from "react";
import Barcode from "react-barcode";
import JsBarcode from "jsbarcode";
import { useHistory } from "react-router-dom";
import ReactToPrint from "react-to-print";
import _ from "lodash";

// icons
import SearchIcon from "@mui/icons-material/Search";
import PrintIcon from "@mui/icons-material/Print";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";

// components
import CustomButton from "../../../components/CustomButton";
import { convertCurrency, numberFormat } from "../../../helper";
import AnimationLoading from "../../../components/Animationloading";
import PaginationHelper from "../../../components/PaginationHelper";
import { LINEAR_GRADIENT_BG, USER_KEY } from "../../../const";

// apollo
import { useLazyQuery } from "@apollo/client";
import { GET_PRODUCTS } from "../../../apollo/product/query";
import { GET_BRANDS } from "../../../apollo/brand/Query";
import { GET_CATEGORYS } from "../../../apollo/category/query";

// bootrap
import { Form, Button, Modal, Table, Tabs, Tab } from "react-bootstrap";
import EmptyComponent from "../../../components/EmptyComponent";
import { Breadcrumb } from "antd";
import BreadCrumbComponent from "../../../components/BreadCrumbComponent";
import { errorSwal } from "../../../helper/sweetalert";
import BarcodeProductVariant from "./BarcodeProductVariant";

export default function BarCodeLaBel() {
  const shopId = JSON.parse(localStorage.getItem(USER_KEY))?.data?.shop?.id;
  const history = useHistory();
  const [product, setProduct] = useState();
  const [selectedItems, setSelectedItems] = useState([]);
  const [barcodeMulti, setBarcodeMulti] = useState();
  const [showbarcodeMulti, setShowBarcodeMulti] = useState(false);
  const [previewBarcode, setPreViewBarcode] = useState(false);
  const [brand, setBrand] = useState();
  const [category, setCategory] = useState();
  const [productTotal, setProductTotal] = useState(0);
  const [selectCategory, setSelectCategory] = useState();
  const currentCategory = localStorage.getItem("CURRENT_CATEGORY");
  const currentBrand = localStorage.getItem("CURRENT_BRAND");
  const [searchText, setSearchText] = useState("");
  const [searchBrand, setSearchBrand] = useState();
  const [searchCategory, setSearchCategory] = useState();
  const [activeTab, setActiveTab] = useState("product");
  const ref = useRef();

  const [isChecked, setIsChecked] = useState(false);
  const [isSelectAll, setIsSelectAll] = useState(false);
  const [isPrice, setIsPrice] = useState(true);

  const toggleDiv = () => {
    setIsChecked(!isChecked);
  };

  //Pagination
  const [pageNumber, setPageNumber] = useState(1);

  // Paggination helper
  const { _limit, _skip, Pagination_helper } = PaginationHelper();

  const [getproduct, { data: getproductData, loading }] = useLazyQuery(
    GET_PRODUCTS,
    { fetchPolicy: "cache-and-network" }
  );

  const [LoadBrand, { data: GetBrandData, loading: loadingBrand }] =
    useLazyQuery(GET_BRANDS, { fetchPolicy: "network-only" });

  const [LoadCategory, { data: GetCategoryData, loading: loadingCategory }] =
    useLazyQuery(GET_CATEGORYS, { fetchPolicy: "network-only" });


  const [selectedOption, setSelectedOption] = useState("option1");

  const handleInputChange = (event) => {
    setSelectedOption(event.target.value);
  };

  // ==========> useEffect <==========

  useEffect(() => {
    // Retrieve the checkbox state from localStorage on component mount
    const storedCheckboxState = localStorage.getItem("checkboxState");
    setIsChecked(storedCheckboxState === "true");
  }, []);

  useEffect(() => {
    // Update localStorage whenever the checkbox state changes
    localStorage.setItem("checkboxState", isChecked);
  }, [isChecked]);

  useEffect(() => {
    if (getproductData) {
      setProduct(getproductData?.products?.data);
      setProductTotal(getproductData?.products?.total);
    }
  }, [getproductData]);

  useEffect(() => {
    if (GetCategoryData) {
      const result = (GetCategoryData?.categories?.data).sort((a, b) =>
        a?.name?.localeCompare(b?.name)
      );
      setCategory(result);
    }
  }, [GetCategoryData]);

  useEffect(() => {
    if (GetBrandData) {
      const result = (GetBrandData?.brands?.data).sort((a, b) =>
        a?.name?.localeCompare(b?.name)
      );
      setBrand(result);
      setSelectCategory(GetBrandData?.brands?.data?.category?.id);
    }
  }, [GetBrandData]);

  useEffect(() => {
    _filter();
    filterBrand();
  }, [searchText, searchBrand, searchCategory, pageNumber, _skip]);

  useEffect(() => {
    // TODO: Get all category
    LoadCategory({
      variables: {
        limit: 800,
        where: {
          shop: shopId,
          isDeleted: false,
        },
      },
    });

    _filter();
  }, []);

  // ==========> Fuction  <==========

  const filterBrand = () => {
    let _where = {
      shop: shopId,
      isDeleted: false,
      // category: searchCategory
    };
    if (!_.isEmpty(searchCategory) && searchCategory !== "ALL") {
      // console.log("step 2")
      // console.log("searchCategory", searchCategory)
      _where = { ..._where, category: searchCategory };
    }

    // TODO: Get all brand
    LoadBrand({
      variables: {
        limit: 800,
        where: _where,
      },
    });
  };

  const _filter = async () => {
    try {
      // console.log("step 1")
      let shopId = JSON.parse(localStorage.getItem("SHOP_DATA"))?.id;

      let _where = {
        shop: shopId,
        isDeleted: false,
      };

      // TODO: check if search text is not empty
      if (!_.isEmpty(searchText)) {
        _where = { ..._where, name: searchText };
      }

      if (!_.isEmpty(searchBrand) && searchBrand !== "ALL") {
        // const _newSearchBrand = brand.find(({ id }) => id === searchBrand)
        _where = { ..._where, brand: searchBrand };
      }

      if (!_.isEmpty(searchCategory) && searchCategory !== "ALL") {
        // console.log("step 2")
        // const _newSearchCategory = category.find(({ id }) => id === searchCategory)
        _where = { ..._where, category: searchCategory };
      }

      // TODO: Get all product
      getproduct({
        variables: {
          skip: (_skip - 1) * _limit,
          limit: _limit,
          orderBy: "createdAt_DESC",
          where: _where,
        },
      });
    } catch (error) {
      console.log("Error: ", error);
    }
  };



  const _checkSelected = (_barcode) => {
    const _check = selectedItems.some((item) => item?.barCode === _barcode);
    return _check;
  };

  const handleShowbarcode = () => {
    setBarcodeMulti(selectedItems);
    setShowBarcodeMulti(true);
  };

  const handleCheckboxChangeCount = (event, index) => {
    const updatedItems = [...selectedItems];
    updatedItems[index].count = parseInt(event.target.value);
    setSelectedItems(updatedItems);
  };

  // =========== 2 row barcode

  const barcodeElements = (
    count,
    barcode,
    priceOptions,
    price,
    currency,
    name
  ) =>
    Array.from({ length: count, barcode }, (_, index) => {
      if (selectedOption === "option3") {
        return (
          <div
            // className="col-8"
            style={{
              // height: "35mm",
              // width: "40mm",
              height: "30mm",
              width: "50mm",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
              // border: '1px solid #f2f2f2',
              marginBottom: 3
            }}>
            <div>
              <div
                style={{
                  fontSize: 10,
                  // whiteSpace: "nowrap",
                  // overflow: "hidden",
                  // textOverflow: "ellipsis",
                  // width: "50mm",
                }}>
                {name}
              </div>
              {isPrice ? (
                <div style={{ fontSize: 12, lineHeight: "12px" }}>
                  {numberFormat(priceOptions[0]?.price ?? price)}{" "}
                  {convertCurrency(currency)}
                </div>
              ) : (
                <div style={{ fontSize: 12, lineHeight: "12px" }}>
                  .....................
                </div>
              )}
              <Barcode
                key={index}
                value={`${barcode}`}
                format={barcode.length == 13 ? "EAN13" : "CODE128"}
                displayValue={true}
                // width={barcode.length == 13 ? 1 : 1.3}
                width={1.5}
                height={32}
                fontSize={10}
                fontWeight="bold"
              />
            </div>
          </div>
        )
      } else {
        return (
          <div
            className={selectedOption === "option2" ? "col-6" : "col-4"}
            style={{
              height: selectedOption === "option2" ? "25.911mm" : "25.5mm",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
            }}>
            <div>
              <div
                style={{
                  fontSize: 10,
                  whiteSpace:  "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  width: 120,
                }}>
                {name}
              </div>
              {isPrice ? (
                <div style={{ fontSize: 10, lineHeight: "12px" }}>
                  {numberFormat(priceOptions[0]?.price ?? price)}{" "}
                  {convertCurrency(currency)}
                </div>
              ) : (
                <div style={{ fontSize: 10, lineHeight: "12px" }}>
                  .....................
                </div>
              )}
              <Barcode
                key={index}
                value={`${barcode}`}
                format={barcode.length == 13 ? "EAN13" : "CODE128"}
                displayValue={true}
                width={barcode.length == 13 ? 1 : 1.3}
                height={14}
                fontSize={10}
              />
            </div>
          </div>
        )
      }
    });

  // Select all product items
  const onSelectedAllProducts = async () => {
    if (isSelectAll) {
      setSelectedItems([]);
      setIsSelectAll(false);
    } else {
      let _dataForSelectAll = [];
      console.log("productAll:--", product)

      for (let i = 0; i < product.length; i++) {
        if (!_.isEmpty(product[i]?.barCode)) {
          _dataForSelectAll.push({ ...product[i], count: 1 });
        }
      }
      setSelectedItems(_dataForSelectAll);
      setIsSelectAll(true);
    }
  };


  // select sign item 
  const handleCheckboxChange = (event) => {
    if (_.isEmpty(event.barCode)) {
      console.log("single select:2:", event)
      errorSwal("ບໍ່ມີລະຫັດ ບຣາໂຄດ. ກະລຸນາສ້າງບຣາໂຄດກ່ອນ!")
      return;
    }
    const _check = selectedItems.some(
      (item) => item?.id === event?.id
    );
    if (_check) {
      const _newSelectedItems = selectedItems.filter(
        (item) => item?.id !== event.id
      );
      setSelectedItems(_newSelectedItems);
      return;
    }

    const _newSelectedItems = [...selectedItems, { ...event, count: 1 }];
    setSelectedItems(_newSelectedItems);
  };


  return (
    <React.Fragment>
      <div style={{ padding: "1em" }}>
        <BreadCrumbComponent
          goback={() => history.goBack()}
          txtFirst="ຕັ້ງຄ່າ"
          txtSecond="ພິມບາຮໂຄ້ດ"
        />

        <Tabs
          activeKey={activeTab}
          onSelect={(key) => setActiveTab(key)}
          className="mb-3">
          <Tab eventKey="product" title="ສິນຄ້າ">
            <div
              style={{
                backgroundColor: "#FFFFFF",
                padding: 25
              }}>
              <div
                style={{
                  height: "60px",
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  paddingBottom: 10,
                }}>
                <div style={{ width: "100%" }}>
                  <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                    <Form.Label>ຊື່ສິນຄ້າ</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="ຄົ້ນຫາສິນຄ້າ..."
                      onChange={(e) => {
                        setSearchText(e.target.value);
                      }}
                      value={searchText}
                    />
                  </Form.Group>
                </div>
                &emsp;
                <div style={{ width: "60%" }}>
                  <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                    <Form.Label>ປະເພດ</Form.Label>
                    <Form.Select
                      onChange={(e) => {
                        setSearchCategory(e.target.value);
                        localStorage.setItem("CURRENT_CATEGORY", e.target.value);
                        localStorage.removeItem("CURRENT_BRAND");
                        setSearchBrand();
                      }}
                      value={searchCategory}>
                      <option value="ALL">--ເລືອກ--</option>
                      {category?.map((categorys) => (
                        <option key={categorys.id} value={categorys?.id}>
                          {categorys?.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>

                </div>
                &emsp;
                <div style={{ width: "60%" }}>
                  <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                    <Form.Label>ແບຣນ</Form.Label>
                    <Form.Select
                      onChange={(e) => {
                        setSearchBrand(e.target.value);
                        localStorage.setItem("CURRENT_BRAND", e.target.value);
                      }}
                      value={searchBrand}>
                      <option value="ALL">--ເລືອກ--</option>
                      {brand?.map((brands, index) => (
                        <option key={brands + index} value={brands?.id}>
                          {brands?.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>

                </div>
                &emsp;
                <div style={{ width: "40%", paddingTop: 10 }}>
                  <CustomButton
                    icon={<PrintIcon />}
                    title="ປິ້ນບຣາໂຄດ"
                    color={"white"}
                    width="100%"
                    height={45}
                    borderRadius={8}
                    capacitys={selectedItems?.length <= 0 ? "50%" : "100%"}
                    onClick={selectedItems?.length <= 0 ? <></> : handleShowbarcode}
                  />
                </div>
              </div>
              {loading && !getproductData ? (
                <AnimationLoading />
              ) : (
                <>
                  {product?.length > 0 ? (
                    <Table hover responsive>
                      <thead
                        style={{
                          background: LINEAR_GRADIENT_BG,
                          borderRadius: " 8px 8px 0px 0px",
                          color: "#FFFFFF",
                          padding: "1em 0",
                        }}>
                        <tr>
                          <th style={{ padding: "1em" }}>
                            <Form.Check
                              aria-label="option 1"
                              style={{ cursor: 'pointer' }}
                              checked={isSelectAll}
                              onChange={() => onSelectedAllProducts()}
                              label="ເລືອກ"
                              id="ເລືອກ"
                            />

                          </th>
                          <th style={{ padding: "1em" }}>ຊື່ສິນຄ້າ</th>
                          <th style={{ padding: "1em" }}>ລະຫັດບາໂຄດ</th>
                          <th style={{ padding: "1em" }}>ປະເພດສິນຄ້າ</th>
                          <th style={{ padding: "1em" }}>ເເບຣນ</th>
                          <th style={{ padding: "1em" }}>ຈຳນວນສິນຄ້າ</th>
                          <th style={{ padding: "1em" }}>ລາຄາສິນຄ້າ1</th>
                          <th style={{ padding: "1em" }}>ລາຄາສິນຄ້າ2</th>
                          <th style={{ padding: "1em" }}>ລາຄາສິນຄ້າ3</th>

                        </tr>
                      </thead>
                      <tbody>
                        {product?.map((p, index) => (
                          <tr key={index} style={{ color: p?.barCode ? "#000" : '#777', userSelect: p?.barCode ? '' : "none" }}>
                            <td style={{ padding: "1em" }}>
                              {isSelectAll ? (
                                <>
                                  {p?.barCode ? (
                                    <Form.Check
                                      aria-label="option 12"
                                      value={p?.id}
                                      label={index + 1 + _limit * (_skip - 1)}
                                      checked
                                    />
                                  ) : (
                                    <Form.Check
                                      aria-label="option 12"
                                      value={p?.id}
                                      label={index + 1 + _limit * (_skip - 1)}
                                    />
                                  )}
                                </>
                              ) : (
                                <Form.Check
                                  style={{ cursor: 'pointer' }}
                                  aria-label="option 1"
                                  value={p?.id}
                                  label={index + 1 + _limit * (_skip - 1)}
                                  id={index + 1 + _limit * (_skip - 1)}
                                  checked={selectedItems.some(item => item?.id === p?.id)}
                                  onChange={() => handleCheckboxChange(p)}
                                />
                              )}
                            </td>
                            <td style={{
                              padding: "1em",
                            }}>
                              <div style={{
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                width: 230,
                              }}>
                                {p?.name ?? "-"}
                              </div>
                            </td>
                            <td style={{ padding: "1em" }}>{p?.barCode ?? "-"}</td>
                            <td style={{ padding: "1em" }}>
                              {p?.category?.name ?? p?.categoryName ?? "-"}
                            </td>
                            <td style={{ padding: "1em" }}>
                              {p?.brand?.name ?? "-"}
                            </td>
                            <td style={{ padding: "1em" }}>
                              {numberFormat(p?.amount)}
                            </td>
                            <td style={{ padding: "1em" }}>
                              {numberFormat(p?.priceOptions[0]?.price ?? p?.price)}
                            </td>
                            <td style={{ padding: "1em" }}>
                              {isNaN(p?.priceOptions[1]?.price)
                                ? 0
                                : numberFormat(p?.priceOptions[1]?.price)}
                            </td>
                            <td style={{ padding: "1em" }}>
                              {isNaN(p?.priceOptions[2]?.price)
                                ? 0
                                : numberFormat(p?.priceOptions[2]?.price)}
                              {/* {numberFormat(p?.priceOptions[2]?.price)} */}
                            </td>

                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  ) : (
                    <div>
                      {product?.length <= 0 && (
                        <div
                          style={{
                            fontSize: "24px",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            color: "#6B7280",
                            fontWeight: "400",
                          }}>
                          <EmptyComponent />
                          <p>ຍັງບໍ່ມີສິນຄ້າກະລຸນາໄປເພີ່ມສິນຄ້າໃນສະຕອັກກ່ອນ !!!</p>
                        </div>
                      )}
                    </div>
                  )}

                  {productTotal > 0 ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-around",
                        alignItems: "center",
                      }}>
                      {productTotal && (
                        <div className="show">
                          ກຳລັງສະແດງ {50 * _skip - 49}-
                          {50 * _skip > productTotal ? productTotal : 50 * _skip}{" "}
                          ຈາກ {productTotal}
                        </div>
                      )}
                      <div>{Pagination_helper(productTotal, "", ``)}</div>
                      <div></div>
                      <div />
                    </div>
                  ) : (
                    ""
                  )}
                </>
              )}
            </div>
          </Tab>
          <Tab eventKey="variant" title="ສິນຄ້າ Variant">
            <BarcodeProductVariant />
          </Tab>
        </Tabs>
      </div>
      <Modal
        show={showbarcodeMulti}
        onHide={() => {
          setShowBarcodeMulti(false);
        }}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        backdrop="static"
        keyboard={false}
        centered>
        <Modal.Header closeButton>
          <Modal.Title>
            ລາຍການພິມບາຮໂຄ້ດ({barcodeMulti?.length} ລາຍການ)
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ padding: 10 }}>
          <div style={{ display: "flex", paddingBottom: "10px" }}>
            <div
              style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                fontSize: 18,
              }}>
              <div>ຂະໜາດເຈ້ຍພິມ</div>
              <div style={{ display: "flex", gap: 5 }}>
                  <div style={{ marginLeft: 20 }}>
                    <label>
                      <input
                        type="radio"
                        name="choice"
                        value="option3"
                        checked={selectedOption === "option3"}
                        onChange={handleInputChange}
                        style={{ transform: "scale(2.0)" }}
                      />
                      &emsp;1ດວງ
                    </label>
                  </div>
                  <div style={{ marginLeft: 20 }}>
                    <label>
                      <input
                        type="radio"
                        name="choice"
                        value="option2"
                        checked={selectedOption === "option2"}
                        onChange={handleInputChange}
                        style={{ transform: "scale(2.0)" }}
                      />
                      &emsp;2ດວງ
                    </label>
                  </div>
                  <div style={{ marginLeft: 20 }}>
                    <label>
                      <input
                        type="radio"
                        name="choice"
                        value="option1"
                        checked={selectedOption === "option1"}
                        onChange={handleInputChange}
                        style={{ transform: "scale(2.0)" }}
                      />
                      &emsp;3ດວງ
                    </label>
                  </div>
                </div>
            </div>
            <div style={{ width: "50%", display: "flex", justifyContent: "end" }}>
              <Button 
              onClick={() => {
                setShowBarcodeMulti(false);
                setSelectedItems([]);
                setBarcodeMulti();
              }}
              variant="outline-secondary"
              >ຍົກເລີກ</Button>
               
              &emsp;
              <ReactToPrint
                trigger={() => (
                  <CustomButton
                    background={LINEAR_GRADIENT_BG}
                    width="30%"
                    height={40}
                    title={"ພິມ"}
                    icon={<PrintIcon />}
                    borderRadius="5px"
                  />
                )}
                content={() => ref.current}
              />
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "auto",
            }}>
            <Table hover>
              <thead
                style={{
                  background:
                    "#1F3A60",
                  borderRadius: " 8px 8px 0px 0px",
                  color: "#FFFFFF",
                }}>
                <tr>
                  <th>#</th>
                  <th>ຊື່ສິນຄ້າ</th>
                  <th>ລະຫັດບາໂຄດ</th>
                  <th>ປະເພດສິນຄ້າ</th>
                  {/* <th>ເເບຮນສິນຄ້າ</th> */}
                  <th style={{ width: "15%" }}>ຈຳນວນ</th>
                </tr>
              </thead>
              <tbody>
                {selectedItems?.map((b, Onindex) => (
                  <tr>
                    <td>{Onindex + 1}</td>
                    <td>{b?.name ?? "-"}</td>
                    <td>{b?.barCode ?? "-"}</td>
                    <td>{b?.category?.name ?? "-"}</td>
                    {/* <td>{b?.brand?.name ?? "-"}</td> */}
                    <td>
                      <Form.Control
                        min="1"
                        type="number"
                        onChange={(e) => handleCheckboxChangeCount(e, Onindex)}
                        name="count"
                        value={b?.count}
                        placeholder="ຈຳນວນ..."
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>

          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ fontSize: 20, fontWeight: "600" }}>
              ຮູບເເບບຕົວຢ່າງ Barcode
            </div>
            <div style={{ padding: "1.5em 0" }}>
              <Form.Check
                type="switch"
                id="custom-switch"
                label={!isPrice ? "ສະແດງລາຄາ" : "ບໍ່ສະແດງລາຄາ"}
                name="isPrice"
                onChange={(e) => setIsPrice(e?.target?.checked)}
                checked={isPrice}
              />
            </div>
          </div>

          <div style={{ padding: 20 }}>
            <div
              ref={ref}
              className={selectedOption === "option3" ? "" : "row"}
              style={{ paddingLeft: selectedOption === "option3" ? 0 : "15px", paddingRight: selectedOption === "option3" ? 0 : "15px" }}>
              {selectedItems?.map(
                (
                  { barCode, count, priceOptions, price, currency, name },
                  index
                ) => {
                  return barcodeElements(
                    count,
                    barCode,
                    priceOptions,
                    price,
                    currency,
                    name
                  );
                }
              )}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
}
